import { createContext, useContext, useState, useEffect } from "react";

const translations = {
  fr: {
    // Landing
    slogan: "B\u00e2tisseurs de confiance et d'avenir",
    construction: "Construction",
    travaux: "Travaux",
    constructionSub: "Maisons, Villas & Immeubles d'exception",
    travauxSub: "G\u00e9nie civil, Infrastructures & Am\u00e9nagement",

    // Nav
    home: "Accueil",
    contact: "Contact",

    // Construction page
    constHeroOverline: "KMSN Construction",
    constHeroTitle1: "Construisons",
    constHeroTitle2: "l'excellence",
    constAboutOverline: "Notre expertise",
    constAboutTitle: "Des r\u00e9alisations d'exception",
    constAboutP1: "KMSN Construction est une entreprise sp\u00e9cialis\u00e9e dans la construction de maisons, villas et immeubles. Nous mettons un point d'honneur \u00e0 conjuguer professionnalisme, rigueur et savoir-faire \u00e0 chaque \u00e9tape de nos r\u00e9alisations.",
    constAboutP2: "Notre engagement envers la durabilit\u00e9 guide nos choix techniques et nos m\u00e9thodes, pour construire des ouvrages solides, fiables et responsables.",
    constServicesOverline: "Nos services",
    constServicesTitle: "Ce que nous construisons",
    constService1Title: "Construction de Maisons",
    constService1Desc: "Conception et r\u00e9alisation de maisons individuelles modernes et fonctionnelles.",
    constService2Title: "Construction de Villas",
    constService2Desc: "Cr\u00e9ation de villas contemporaines ou traditionnelles avec piscines et espaces ext\u00e9rieurs sur mesure.",
    constService3Title: "Construction d'Immeubles",
    constService3Desc: "R\u00e9alisation de projets immobiliers d'envergure, immeubles r\u00e9sidentiels et commerciaux.",
    constGalleryOverline: "Nos projets",
    constGalleryTitle: "R\u00e9alisations r\u00e9centes",
    constProcessOverline: "Notre processus",
    constProcessTitle: "Votre projet en 4 \u00e9tapes",
    constProcess1Title: "\u00c9tude et conception",
    constProcess1Desc: "Analyse approfondie du projet et \u00e9laboration des plans personnalis\u00e9s.",
    constProcess2Title: "Pr\u00e9paration du chantier",
    constProcess2Desc: "Structuration technique, planification et mobilisation des \u00e9quipes.",
    constProcess3Title: "R\u00e9alisation des travaux",
    constProcess3Desc: "Ex\u00e9cution des travaux dans les r\u00e8gles de l'art, avec un suivi continu.",
    constProcess4Title: "Livraison et contr\u00f4le",
    constProcess4Desc: "V\u00e9rifications minutieuses, finitions et remise des cl\u00e9s.",
    constContactOverline: "Contactez-nous",
    constContactTitle: "Un projet de construction ?",
    constContactDesc: "D\u00e9crivez-nous votre projet et notre \u00e9quipe vous accompagnera de A \u00e0 Z.",
    respectDelais: "Respect des d\u00e9lais",
    satisfactionClient: "Satisfaction client",
    qualiteMat: "Qualit\u00e9 mat\u00e9riaux",
    securiteChantier: "S\u00e9curit\u00e9 chantier",
    gallery1Title: "Riad Traditionnel",
    gallery1Desc: "Architecture marocaine authentique",
    gallery2Title: "Villa Prestige",
    gallery2Desc: "Construction haut de gamme",
    gallery3Title: "Villa Moderne",
    gallery3Desc: "Design contemporain avec piscine",
    gallery4Title: "Villa Contemporaine",
    gallery4Desc: "Architecture moderne",

    // Travaux page
    travHeroOverline: "KMSN Travaux",
    travHeroTitle1: "Des solutions",
    travHeroTitle2: "durables",
    travAboutOverline: "KMSN Travaux",
    travAboutTitle: "Un partenaire fiable pour vos projets",
    travAboutP1: "KMSN est une entreprise marocaine de travaux publics sp\u00e9cialis\u00e9e dans les projets d'infrastructures et d'am\u00e9nagement. Nous mettons un point d'honneur \u00e0 conjuguer professionnalisme, rigueur et savoir-faire \u00e0 chaque \u00e9tape de nos r\u00e9alisations.",
    travAboutP2: "Notre engagement envers la durabilit\u00e9 guide nos choix techniques et nos m\u00e9thodes, pour construire des ouvrages solides, fiables et responsables.",
    travServicesOverline: "Nos services",
    travServicesTitle: "Nos domaines d'intervention",
    travService1Title: "Travaux Divers",
    travService1Desc: "R\u00e9alisation de travaux de g\u00e9nie civil, constructions d'ouvrages solides et durables : fondations, structures en b\u00e9ton arm\u00e9.",
    travService2Title: "Entretien de Voies de Communication",
    travService2Desc: "Am\u00e9nagement, construction et entretien de routes, chemins, parkings et pistes pour une mobilit\u00e9 s\u00e9curis\u00e9e.",
    travService3Title: "Canalisation d'Eau et d'\u00c9gout",
    travService3Desc: "Installation et maintenance de r\u00e9seaux d'adduction d'eau potable et syst\u00e8mes d'assainissement.",
    travService4Title: "Transport de Marchandises",
    travService4Desc: "Transport de marchandises pour le compte d'autrui, logistique et gestion des livraisons sur chantier.",
    travService5Title: "Sondeur / Foreur de Puits",
    travService5Desc: "R\u00e9alisation de forages et sondages pour l'acc\u00e8s aux ressources hydrauliques souterraines.",
    travService6Title: "Installation Panneaux Solaires",
    travService6Desc: "Conception et installation de syst\u00e8mes photovolta\u00efques pour une \u00e9nergie propre et renouvelable.",
    travService7Title: "Travaux de D\u00e9molition",
    travService7Desc: "D\u00e9molition contr\u00f4l\u00e9e et s\u00e9curis\u00e9e de structures existantes avec gestion des d\u00e9bris.",
    travService8Title: "Tri et Gestion",
    travService8Desc: "Tri, recyclage et gestion responsable des d\u00e9chets de chantier pour un impact environnemental r\u00e9duit.",
    travStatsProjects: "Projets r\u00e9alis\u00e9s",
    travStatsSatisfaction: "Satisfaction client",
    travStatsEquipment: "\u00c9quipements",
    travStatsExperience: "Ann\u00e9es d'exp\u00e9rience",
    travProcessOverline: "Notre processus",
    travProcessTitle: "Notre m\u00e9thode de travail",
    travProcess1Title: "\u00c9tude et conception personnalis\u00e9e",
    travProcess1Desc: "Analyse approfondie du projet et \u00e9laboration des plans adapt\u00e9s.",
    travProcess2Title: "R\u00e9alisation et suivi rigoureux",
    travProcess2Desc: "Ex\u00e9cution des travaux dans les r\u00e8gles de l'art, avec un suivi continu.",
    travProcess3Title: "Livraison et contr\u00f4le qualit\u00e9",
    travProcess3Desc: "Finalisation du projet avec des v\u00e9rifications minutieuses.",
    travCtaTitle: "Vous avez un projet innovant ?",
    travCtaDesc: "Construisons-le ensemble avec expertise et engagement.",
    travCtaBtn: "Devis gratuit",
    travContactOverline: "Contactez-nous",
    travContactTitle: "Un projet de travaux ?",
    travContactDesc: "Partagez les d\u00e9tails de votre projet et recevez un devis personnalis\u00e9.",
    professionnalisme: "Professionnalisme",
    professionnalismeDesc: "Chaque projet est pris en charge avec s\u00e9rieux et engagement total.",
    maitriseTechnique: "Ma\u00eetrise technique",
    maitriseTechniqueDesc: "Expertise confirm\u00e9e dans tous les aspects du BTP.",
    respectDelaisShort: "Respect des d\u00e9lais",
    respectDelaisShortDesc: "Travaux r\u00e9alis\u00e9s dans les temps convenus.",
    equipeQualifiee: "\u00c9quipe qualifi\u00e9e",
    equipeQualifieeDesc: "Des professionnels exp\u00e9riment\u00e9s et d\u00e9di\u00e9s.",

    // Contact form
    formName: "Nom complet",
    formNamePlaceholder: "Votre nom",
    formEmail: "Email",
    formEmailPlaceholder: "votre@email.com",
    formPhone: "T\u00e9l\u00e9phone",
    formPhonePlaceholder: "+212 6XX XXX XXX",
    formSubject: "Sujet",
    formSubjectPlaceholder: "Sujet de votre message",
    formMessage: "Message",
    formMessagePlaceholder: "D\u00e9crivez votre projet...",
    formSend: "Envoyer le message",
    formSending: "Envoi en cours...",
    formSuccess: "Message envoy\u00e9 !",
    formSuccessDesc: "Merci pour votre message. Notre \u00e9quipe vous recontactera dans les plus brefs d\u00e9lais.",
    formAnother: "Envoyer un autre message",
    formError: "Une erreur est survenue. Veuillez r\u00e9essayer.",
    whatsappContact: "Ou contactez-nous directement via WhatsApp :",

    // Footer
    navigation: "Navigation",
    contactTitle: "Contact",
    followUs: "Suivez-nous",
    footerDesc: "KMSN est une entreprise sp\u00e9cialis\u00e9e dans la construction et les travaux publics, alliant expertise, qualit\u00e9 et durabilit\u00e9 pour chaque projet.",
    allRights: "Tous droits r\u00e9serv\u00e9s.",

    // Admin
    adminTitle: "KMSN Admin",
    adminBack: "Retour au site",
    adminLogin: "Connexion Admin",
    adminEmail: "Email",
    adminPassword: "Mot de passe",
    adminLoginBtn: "Se connecter",
    adminMessages: "Messages re\u00e7us",
    adminNoMessages: "Aucun message pour le moment",
    adminDetails: "D\u00e9tails",
    adminSelectMsg: "S\u00e9lectionnez un message",
    adminDelete: "Supprimer ce message",
    adminLoading: "Chargement...",
    adminTotalMessages: "Total messages",
    adminUnread: "Non lus",
    adminLogout: "D\u00e9connexion",
  },

  en: {
    slogan: "Builders of trust and future",
    construction: "Construction",
    travaux: "Works",
    constructionSub: "Houses, Villas & Exceptional Buildings",
    travauxSub: "Civil Engineering, Infrastructure & Development",
    home: "Home",
    contact: "Contact",
    constHeroOverline: "KMSN Construction",
    constHeroTitle1: "Let's build",
    constHeroTitle2: "excellence",
    constAboutOverline: "Our expertise",
    constAboutTitle: "Exceptional achievements",
    constAboutP1: "KMSN Construction is a company specializing in the construction of houses, villas and buildings. We are committed to combining professionalism, rigor and expertise at every stage of our projects.",
    constAboutP2: "Our commitment to sustainability guides our technical choices and methods, to build solid, reliable and responsible structures.",
    constServicesOverline: "Our services",
    constServicesTitle: "What we build",
    constService1Title: "House Construction",
    constService1Desc: "Design and construction of modern and functional individual houses.",
    constService2Title: "Villa Construction",
    constService2Desc: "Creation of contemporary or traditional villas with pools and custom outdoor spaces.",
    constService3Title: "Building Construction",
    constService3Desc: "Large-scale real estate projects, residential and commercial buildings.",
    constGalleryOverline: "Our projects",
    constGalleryTitle: "Recent achievements",
    constProcessOverline: "Our process",
    constProcessTitle: "Your project in 4 steps",
    constProcess1Title: "Study and design",
    constProcess1Desc: "In-depth project analysis and personalized plan development.",
    constProcess2Title: "Site preparation",
    constProcess2Desc: "Technical structuring, planning and team mobilization.",
    constProcess3Title: "Construction work",
    constProcess3Desc: "Execution of work according to best practices, with continuous monitoring.",
    constProcess4Title: "Delivery and control",
    constProcess4Desc: "Thorough inspections, finishing touches and key handover.",
    constContactOverline: "Contact us",
    constContactTitle: "A construction project?",
    constContactDesc: "Describe your project and our team will support you from A to Z.",
    respectDelais: "On-time delivery",
    satisfactionClient: "Client satisfaction",
    qualiteMat: "Material quality",
    securiteChantier: "Site safety",
    gallery1Title: "Traditional Riad",
    gallery1Desc: "Authentic Moroccan architecture",
    gallery2Title: "Prestige Villa",
    gallery2Desc: "High-end construction",
    gallery3Title: "Modern Villa",
    gallery3Desc: "Contemporary design with pool",
    gallery4Title: "Contemporary Villa",
    gallery4Desc: "Modern architecture",
    travHeroOverline: "KMSN Works",
    travHeroTitle1: "Sustainable",
    travHeroTitle2: "solutions",
    travAboutOverline: "KMSN Works",
    travAboutTitle: "A reliable partner for your projects",
    travAboutP1: "KMSN is a Moroccan public works company specialized in infrastructure and development projects. We are committed to combining professionalism, rigor and expertise at every stage of our work.",
    travAboutP2: "Our commitment to sustainability guides our technical choices and methods, to build solid, reliable and responsible structures.",
    travServicesOverline: "Our services",
    travServicesTitle: "Our areas of intervention",
    travService1Title: "General Works",
    travService1Desc: "Civil engineering works, construction of solid and durable structures: foundations, reinforced concrete structures.",
    travService2Title: "Road Maintenance",
    travService2Desc: "Development, construction and maintenance of roads, paths, parking lots and tracks for safe mobility.",
    travService3Title: "Water & Sewer Piping",
    travService3Desc: "Installation and maintenance of drinking water supply networks and sanitation systems.",
    travService4Title: "Freight Transport",
    travService4Desc: "Transport of goods for third parties, logistics and management of site deliveries.",
    travService5Title: "Well Drilling",
    travService5Desc: "Drilling and surveys to access underground hydraulic resources.",
    travService6Title: "Solar Panel Installation",
    travService6Desc: "Design and installation of photovoltaic systems for clean and renewable energy.",
    travService7Title: "Demolition Work",
    travService7Desc: "Controlled and safe demolition of existing structures with debris management.",
    travService8Title: "Sorting & Management",
    travService8Desc: "Sorting, recycling and responsible management of construction waste for reduced environmental impact.",
    travStatsProjects: "Completed projects",
    travStatsSatisfaction: "Client satisfaction",
    travStatsEquipment: "Equipment",
    travStatsExperience: "Years of experience",
    travProcessOverline: "Our process",
    travProcessTitle: "Our working method",
    travProcess1Title: "Personalized study and design",
    travProcess1Desc: "In-depth project analysis and adapted plan development.",
    travProcess2Title: "Rigorous execution and monitoring",
    travProcess2Desc: "Work execution according to best practices, with continuous monitoring.",
    travProcess3Title: "Delivery and quality control",
    travProcess3Desc: "Project finalization with thorough inspections.",
    travCtaTitle: "Have an innovative project?",
    travCtaDesc: "Let's build it together with expertise and commitment.",
    travCtaBtn: "Free quote",
    travContactOverline: "Contact us",
    travContactTitle: "A works project?",
    travContactDesc: "Share your project details and receive a personalized quote.",
    professionnalisme: "Professionalism",
    professionnalismeDesc: "Every project is handled with seriousness and total commitment.",
    maitriseTechnique: "Technical mastery",
    maitriseTechniqueDesc: "Proven expertise in all aspects of construction.",
    respectDelaisShort: "On-time delivery",
    respectDelaisShortDesc: "Work completed on agreed timelines.",
    equipeQualifiee: "Qualified team",
    equipeQualifieeDesc: "Experienced and dedicated professionals.",
    formName: "Full name",
    formNamePlaceholder: "Your name",
    formEmail: "Email",
    formEmailPlaceholder: "your@email.com",
    formPhone: "Phone",
    formPhonePlaceholder: "+212 6XX XXX XXX",
    formSubject: "Subject",
    formSubjectPlaceholder: "Subject of your message",
    formMessage: "Message",
    formMessagePlaceholder: "Describe your project...",
    formSend: "Send message",
    formSending: "Sending...",
    formSuccess: "Message sent!",
    formSuccessDesc: "Thank you for your message. Our team will get back to you as soon as possible.",
    formAnother: "Send another message",
    formError: "An error occurred. Please try again.",
    whatsappContact: "Or contact us directly via WhatsApp:",
    navigation: "Navigation",
    contactTitle: "Contact",
    followUs: "Follow us",
    footerDesc: "KMSN is a company specializing in construction and public works, combining expertise, quality and sustainability for every project.",
    allRights: "All rights reserved.",
    adminTitle: "KMSN Admin",
    adminBack: "Back to site",
    adminLogin: "Admin Login",
    adminEmail: "Email",
    adminPassword: "Password",
    adminLoginBtn: "Sign in",
    adminMessages: "Received messages",
    adminNoMessages: "No messages yet",
    adminDetails: "Details",
    adminSelectMsg: "Select a message",
    adminDelete: "Delete this message",
    adminLoading: "Loading...",
    adminTotalMessages: "Total messages",
    adminUnread: "Unread",
    adminLogout: "Logout",
  },

  ar: {
    slogan: "\u0628\u0646\u0627\u0629 \u0627\u0644\u062b\u0642\u0629 \u0648\u0627\u0644\u0645\u0633\u062a\u0642\u0628\u0644",
    construction: "\u0628\u0646\u0627\u0621",
    travaux: "\u0623\u0634\u063a\u0627\u0644",
    constructionSub: "\u0645\u0646\u0627\u0632\u0644\u060c \u0641\u0644\u0644 \u0648\u0639\u0645\u0627\u0631\u0627\u062a \u0627\u0633\u062a\u062b\u0646\u0627\u0626\u064a\u0629",
    travauxSub: "\u0647\u0646\u062f\u0633\u0629 \u0645\u062f\u0646\u064a\u0629\u060c \u0628\u0646\u064a\u0629 \u062a\u062d\u062a\u064a\u0629 \u0648\u062a\u0647\u064a\u0626\u0629",
    home: "\u0627\u0644\u0631\u0626\u064a\u0633\u064a\u0629",
    contact: "\u0627\u062a\u0635\u0644 \u0628\u0646\u0627",
    constHeroOverline: "KMSN \u0628\u0646\u0627\u0621",
    constHeroTitle1: "\u0644\u0646\u0628\u0646\u064a",
    constHeroTitle2: "\u0627\u0644\u062a\u0645\u064a\u0651\u0632",
    constAboutOverline: "\u062e\u0628\u0631\u062a\u0646\u0627",
    constAboutTitle: "\u0625\u0646\u062c\u0627\u0632\u0627\u062a \u0627\u0633\u062a\u062b\u0646\u0627\u0626\u064a\u0629",
    constAboutP1: "KMSN \u0634\u0631\u0643\u0629 \u0645\u062a\u062e\u0635\u0635\u0629 \u0641\u064a \u0628\u0646\u0627\u0621 \u0627\u0644\u0645\u0646\u0627\u0632\u0644 \u0648\u0627\u0644\u0641\u0644\u0644 \u0648\u0627\u0644\u0639\u0645\u0627\u0631\u0627\u062a. \u0646\u062d\u0631\u0635 \u0639\u0644\u0649 \u0627\u0644\u062c\u0645\u0639 \u0628\u064a\u0646 \u0627\u0644\u0627\u062d\u062a\u0631\u0627\u0641\u064a\u0629 \u0648\u0627\u0644\u062f\u0642\u0629 \u0648\u0627\u0644\u0645\u0647\u0627\u0631\u0629 \u0641\u064a \u0643\u0644 \u0645\u0631\u062d\u0644\u0629.",
    constAboutP2: "\u0627\u0644\u062a\u0632\u0627\u0645\u0646\u0627 \u0628\u0627\u0644\u0627\u0633\u062a\u062f\u0627\u0645\u0629 \u064a\u0648\u062c\u0647 \u062e\u064a\u0627\u0631\u0627\u062a\u0646\u0627 \u0627\u0644\u062a\u0642\u0646\u064a\u0629 \u0648\u0623\u0633\u0627\u0644\u064a\u0628\u0646\u0627 \u0644\u0628\u0646\u0627\u0621 \u0645\u0646\u0634\u0622\u062a \u0635\u0644\u0628\u0629 \u0648\u0645\u0648\u062b\u0648\u0642\u0629.",
    constServicesOverline: "\u062e\u062f\u0645\u0627\u062a\u0646\u0627",
    constServicesTitle: "\u0645\u0627 \u0646\u0628\u0646\u064a\u0647",
    constService1Title: "\u0628\u0646\u0627\u0621 \u0627\u0644\u0645\u0646\u0627\u0632\u0644",
    constService1Desc: "\u062a\u0635\u0645\u064a\u0645 \u0648\u0628\u0646\u0627\u0621 \u0645\u0646\u0627\u0632\u0644 \u0641\u0631\u062f\u064a\u0629 \u0639\u0635\u0631\u064a\u0629 \u0648\u0639\u0645\u0644\u064a\u0629.",
    constService2Title: "\u0628\u0646\u0627\u0621 \u0627\u0644\u0641\u0644\u0644",
    constService2Desc: "\u0625\u0646\u0634\u0627\u0621 \u0641\u0644\u0644 \u0639\u0635\u0631\u064a\u0629 \u0623\u0648 \u062a\u0642\u0644\u064a\u062f\u064a\u0629 \u0645\u0639 \u0645\u0633\u0627\u0628\u062d \u0648\u0645\u0633\u0627\u062d\u0627\u062a \u062e\u0627\u0631\u062c\u064a\u0629.",
    constService3Title: "\u0628\u0646\u0627\u0621 \u0627\u0644\u0639\u0645\u0627\u0631\u0627\u062a",
    constService3Desc: "\u0645\u0634\u0627\u0631\u064a\u0639 \u0639\u0642\u0627\u0631\u064a\u0629 \u0643\u0628\u0631\u0649\u060c \u0639\u0645\u0627\u0631\u0627\u062a \u0633\u0643\u0646\u064a\u0629 \u0648\u062a\u062c\u0627\u0631\u064a\u0629.",
    constGalleryOverline: "\u0645\u0634\u0627\u0631\u064a\u0639\u0646\u0627",
    constGalleryTitle: "\u0625\u0646\u062c\u0627\u0632\u0627\u062a \u062d\u062f\u064a\u062b\u0629",
    constProcessOverline: "\u0639\u0645\u0644\u064a\u062a\u0646\u0627",
    constProcessTitle: "\u0645\u0634\u0631\u0648\u0639\u0643 \u0641\u064a 4 \u062e\u0637\u0648\u0627\u062a",
    constProcess1Title: "\u0627\u0644\u062f\u0631\u0627\u0633\u0629 \u0648\u0627\u0644\u062a\u0635\u0645\u064a\u0645",
    constProcess1Desc: "\u062a\u062d\u0644\u064a\u0644 \u0645\u0639\u0645\u0642 \u0644\u0644\u0645\u0634\u0631\u0648\u0639 \u0648\u0625\u0639\u062f\u0627\u062f \u0627\u0644\u0645\u062e\u0637\u0637\u0627\u062a.",
    constProcess2Title: "\u062a\u062d\u0636\u064a\u0631 \u0627\u0644\u0645\u0648\u0642\u0639",
    constProcess2Desc: "\u0627\u0644\u0647\u064a\u0643\u0644\u0629 \u0627\u0644\u062a\u0642\u0646\u064a\u0629 \u0648\u0627\u0644\u062a\u062e\u0637\u064a\u0637 \u0648\u062a\u0639\u0628\u0626\u0629 \u0627\u0644\u0641\u0631\u0642.",
    constProcess3Title: "\u062a\u0646\u0641\u064a\u0630 \u0627\u0644\u0623\u0634\u063a\u0627\u0644",
    constProcess3Desc: "\u062a\u0646\u0641\u064a\u0630 \u0627\u0644\u0623\u0639\u0645\u0627\u0644 \u0648\u0641\u0642 \u0623\u0639\u0644\u0649 \u0627\u0644\u0645\u0639\u0627\u064a\u064a\u0631 \u0645\u0639 \u0645\u062a\u0627\u0628\u0639\u0629 \u0645\u0633\u062a\u0645\u0631\u0629.",
    constProcess4Title: "\u0627\u0644\u062a\u0633\u0644\u064a\u0645 \u0648\u0627\u0644\u0645\u0631\u0627\u0642\u0628\u0629",
    constProcess4Desc: "\u0641\u062d\u0648\u0635\u0627\u062a \u062f\u0642\u064a\u0642\u0629 \u0648\u0644\u0645\u0633\u0627\u062a \u0623\u062e\u064a\u0631\u0629 \u0648\u062a\u0633\u0644\u064a\u0645 \u0627\u0644\u0645\u0641\u0627\u062a\u064a\u062d.",
    constContactOverline: "\u0627\u062a\u0635\u0644 \u0628\u0646\u0627",
    constContactTitle: "\u0645\u0634\u0631\u0648\u0639 \u0628\u0646\u0627\u0621\u061f",
    constContactDesc: "\u0635\u0641 \u0644\u0646\u0627 \u0645\u0634\u0631\u0648\u0639\u0643 \u0648\u0633\u064a\u0631\u0627\u0641\u0642\u0643 \u0641\u0631\u064a\u0642\u0646\u0627 \u0645\u0646 \u0627\u0644\u0623\u0644\u0641 \u0625\u0644\u0649 \u0627\u0644\u064a\u0627\u0621.",
    respectDelais: "\u0627\u062d\u062a\u0631\u0627\u0645 \u0627\u0644\u0645\u0648\u0627\u0639\u064a\u062f",
    satisfactionClient: "\u0631\u0636\u0627 \u0627\u0644\u0639\u0645\u0644\u0627\u0621",
    qualiteMat: "\u062c\u0648\u062f\u0629 \u0627\u0644\u0645\u0648\u0627\u062f",
    securiteChantier: "\u0623\u0645\u0627\u0646 \u0627\u0644\u0645\u0648\u0642\u0639",
    gallery1Title: "\u0631\u064a\u0627\u0636 \u062a\u0642\u0644\u064a\u062f\u064a",
    gallery1Desc: "\u0639\u0645\u0627\u0631\u0629 \u0645\u063a\u0631\u0628\u064a\u0629 \u0623\u0635\u064a\u0644\u0629",
    gallery2Title: "\u0641\u064a\u0644\u0627 \u0641\u0627\u062e\u0631\u0629",
    gallery2Desc: "\u0628\u0646\u0627\u0621 \u0631\u0627\u0642\u064a",
    gallery3Title: "\u0641\u064a\u0644\u0627 \u0639\u0635\u0631\u064a\u0629",
    gallery3Desc: "\u062a\u0635\u0645\u064a\u0645 \u0645\u0639\u0627\u0635\u0631 \u0645\u0639 \u0645\u0633\u0628\u062d",
    gallery4Title: "\u0641\u064a\u0644\u0627 \u062d\u062f\u064a\u062b\u0629",
    gallery4Desc: "\u0639\u0645\u0627\u0631\u0629 \u062d\u062f\u064a\u062b\u0629",
    travHeroOverline: "KMSN \u0623\u0634\u063a\u0627\u0644",
    travHeroTitle1: "\u062d\u0644\u0648\u0644",
    travHeroTitle2: "\u0645\u0633\u062a\u062f\u0627\u0645\u0629",
    travAboutOverline: "KMSN \u0623\u0634\u063a\u0627\u0644",
    travAboutTitle: "\u0634\u0631\u064a\u0643 \u0645\u0648\u062b\u0648\u0642 \u0644\u0645\u0634\u0627\u0631\u064a\u0639\u0643",
    travAboutP1: "KMSN \u0634\u0631\u0643\u0629 \u0645\u063a\u0631\u0628\u064a\u0629 \u0645\u062a\u062e\u0635\u0635\u0629 \u0641\u064a \u0627\u0644\u0623\u0634\u063a\u0627\u0644 \u0627\u0644\u0639\u0645\u0648\u0645\u064a\u0629 \u0648\u0645\u0634\u0627\u0631\u064a\u0639 \u0627\u0644\u0628\u0646\u064a\u0629 \u0627\u0644\u062a\u062d\u062a\u064a\u0629. \u0646\u062d\u0631\u0635 \u0639\u0644\u0649 \u0627\u0644\u0627\u062d\u062a\u0631\u0627\u0641\u064a\u0629 \u0648\u0627\u0644\u062f\u0642\u0629 \u0641\u064a \u0643\u0644 \u0645\u0631\u062d\u0644\u0629.",
    travAboutP2: "\u0627\u0644\u062a\u0632\u0627\u0645\u0646\u0627 \u0628\u0627\u0644\u0627\u0633\u062a\u062f\u0627\u0645\u0629 \u064a\u0648\u062c\u0647 \u062e\u064a\u0627\u0631\u0627\u062a\u0646\u0627 \u0627\u0644\u062a\u0642\u0646\u064a\u0629 \u0644\u0628\u0646\u0627\u0621 \u0645\u0646\u0634\u0622\u062a \u0635\u0644\u0628\u0629 \u0648\u0645\u0633\u0624\u0648\u0644\u0629.",
    travServicesOverline: "\u062e\u062f\u0645\u0627\u062a\u0646\u0627",
    travServicesTitle: "\u0645\u062c\u0627\u0644\u0627\u062a \u062a\u062f\u062e\u0644\u0646\u0627",
    travService1Title: "\u0623\u0634\u063a\u0627\u0644 \u0645\u062a\u0646\u0648\u0639\u0629",
    travService1Desc: "\u0623\u0634\u063a\u0627\u0644 \u0627\u0644\u0647\u0646\u062f\u0633\u0629 \u0627\u0644\u0645\u062f\u0646\u064a\u0629 \u0648\u0628\u0646\u0627\u0621 \u0645\u0646\u0634\u0622\u062a \u0635\u0644\u0628\u0629: \u0623\u0633\u0627\u0633\u0627\u062a\u060c \u062e\u0631\u0633\u0627\u0646\u0629 \u0645\u0633\u0644\u062d\u0629.",
    travService2Title: "\u0635\u064a\u0627\u0646\u0629 \u0627\u0644\u0637\u0631\u0642",
    travService2Desc: "\u062a\u0647\u064a\u0626\u0629 \u0648\u0628\u0646\u0627\u0621 \u0648\u0635\u064a\u0627\u0646\u0629 \u0627\u0644\u0637\u0631\u0642 \u0648\u0627\u0644\u0645\u0645\u0631\u0627\u062a \u0648\u0627\u0644\u0645\u0648\u0627\u0642\u0641.",
    travService3Title: "\u0642\u0646\u0648\u0627\u062a \u0627\u0644\u0645\u064a\u0627\u0647 \u0648\u0627\u0644\u0635\u0631\u0641",
    travService3Desc: "\u062a\u0631\u0643\u064a\u0628 \u0648\u0635\u064a\u0627\u0646\u0629 \u0634\u0628\u0643\u0627\u062a \u0627\u0644\u0645\u064a\u0627\u0647 \u0627\u0644\u0635\u0627\u0644\u062d\u0629 \u0648\u0627\u0644\u0635\u0631\u0641 \u0627\u0644\u0635\u062d\u064a.",
    travService4Title: "\u0646\u0642\u0644 \u0627\u0644\u0628\u0636\u0627\u0626\u0639",
    travService4Desc: "\u0646\u0642\u0644 \u0627\u0644\u0628\u0636\u0627\u0626\u0639 \u0644\u062d\u0633\u0627\u0628 \u0627\u0644\u063a\u064a\u0631 \u0648\u0625\u062f\u0627\u0631\u0629 \u0627\u0644\u0644\u0648\u062c\u0633\u062a\u064a\u0643.",
    travService5Title: "\u062d\u0641\u0631 \u0627\u0644\u0622\u0628\u0627\u0631",
    travService5Desc: "\u062d\u0641\u0631 \u0648\u0633\u0628\u0631 \u0644\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u0648\u0627\u0631\u062f \u0627\u0644\u0645\u0627\u0626\u064a\u0629 \u0627\u0644\u062c\u0648\u0641\u064a\u0629.",
    travService6Title: "\u062a\u0631\u0643\u064a\u0628 \u0627\u0644\u0623\u0644\u0648\u0627\u062d \u0627\u0644\u0634\u0645\u0633\u064a\u0629",
    travService6Desc: "\u062a\u0635\u0645\u064a\u0645 \u0648\u062a\u0631\u0643\u064a\u0628 \u0623\u0646\u0638\u0645\u0629 \u0627\u0644\u0637\u0627\u0642\u0629 \u0627\u0644\u0634\u0645\u0633\u064a\u0629 \u0627\u0644\u0646\u0638\u064a\u0641\u0629.",
    travService7Title: "\u0623\u0634\u063a\u0627\u0644 \u0627\u0644\u0647\u062f\u0645",
    travService7Desc: "\u0647\u062f\u0645 \u0645\u0646\u0638\u0645 \u0648\u0622\u0645\u0646 \u0644\u0644\u0645\u0646\u0634\u0622\u062a \u0645\u0639 \u0625\u062f\u0627\u0631\u0629 \u0627\u0644\u0623\u0646\u0642\u0627\u0636.",
    travService8Title: "\u0627\u0644\u0641\u0631\u0632 \u0648\u0627\u0644\u0625\u062f\u0627\u0631\u0629",
    travService8Desc: "\u0641\u0631\u0632 \u0648\u0625\u0639\u0627\u062f\u0629 \u062a\u062f\u0648\u064a\u0631 \u0648\u0625\u062f\u0627\u0631\u0629 \u0645\u0633\u0624\u0648\u0644\u0629 \u0644\u0646\u0641\u0627\u064a\u0627\u062a \u0627\u0644\u0628\u0646\u0627\u0621.",
    travStatsProjects: "\u0645\u0634\u0627\u0631\u064a\u0639 \u0645\u0646\u062c\u0632\u0629",
    travStatsSatisfaction: "\u0631\u0636\u0627 \u0627\u0644\u0639\u0645\u0644\u0627\u0621",
    travStatsEquipment: "\u0645\u0639\u062f\u0627\u062a",
    travStatsExperience: "\u0633\u0646\u0648\u0627\u062a \u062e\u0628\u0631\u0629",
    travProcessOverline: "\u0639\u0645\u0644\u064a\u062a\u0646\u0627",
    travProcessTitle: "\u0637\u0631\u064a\u0642\u0629 \u0639\u0645\u0644\u0646\u0627",
    travProcess1Title: "\u062f\u0631\u0627\u0633\u0629 \u0648\u062a\u0635\u0645\u064a\u0645 \u0645\u062e\u0635\u0635",
    travProcess1Desc: "\u062a\u062d\u0644\u064a\u0644 \u0645\u0639\u0645\u0642 \u0648\u0625\u0639\u062f\u0627\u062f \u0645\u062e\u0637\u0637\u0627\u062a \u0645\u0644\u0627\u0626\u0645\u0629.",
    travProcess2Title: "\u062a\u0646\u0641\u064a\u0630 \u0648\u0645\u062a\u0627\u0628\u0639\u0629 \u062f\u0642\u064a\u0642\u0629",
    travProcess2Desc: "\u062a\u0646\u0641\u064a\u0630 \u0627\u0644\u0623\u0639\u0645\u0627\u0644 \u0628\u0623\u0639\u0644\u0649 \u0627\u0644\u0645\u0639\u0627\u064a\u064a\u0631 \u0645\u0639 \u0645\u062a\u0627\u0628\u0639\u0629 \u0645\u0633\u062a\u0645\u0631\u0629.",
    travProcess3Title: "\u0627\u0644\u062a\u0633\u0644\u064a\u0645 \u0648\u0645\u0631\u0627\u0642\u0628\u0629 \u0627\u0644\u062c\u0648\u062f\u0629",
    travProcess3Desc: "\u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0628\u0641\u062d\u0648\u0635\u0627\u062a \u062f\u0642\u064a\u0642\u0629.",
    travCtaTitle: "\u0644\u062f\u064a\u0643 \u0645\u0634\u0631\u0648\u0639 \u0645\u0628\u062a\u0643\u0631\u061f",
    travCtaDesc: "\u0644\u0646\u0628\u0646\u064a\u0647 \u0645\u0639\u064b\u0627 \u0628\u062e\u0628\u0631\u0629 \u0648\u0627\u0644\u062a\u0632\u0627\u0645.",
    travCtaBtn: "\u0639\u0631\u0636 \u0633\u0639\u0631 \u0645\u062c\u0627\u0646\u064a",
    travContactOverline: "\u0627\u062a\u0635\u0644 \u0628\u0646\u0627",
    travContactTitle: "\u0645\u0634\u0631\u0648\u0639 \u0623\u0634\u063a\u0627\u0644\u061f",
    travContactDesc: "\u0634\u0627\u0631\u0643\u0646\u0627 \u062a\u0641\u0627\u0635\u064a\u0644 \u0645\u0634\u0631\u0648\u0639\u0643 \u0648\u0627\u062d\u0635\u0644 \u0639\u0644\u0649 \u0639\u0631\u0636 \u0633\u0639\u0631 \u0645\u062e\u0635\u0635.",
    professionnalisme: "\u0627\u062d\u062a\u0631\u0627\u0641\u064a\u0629",
    professionnalismeDesc: "\u0643\u0644 \u0645\u0634\u0631\u0648\u0639 \u064a\u062a\u0645 \u0627\u0644\u062a\u0639\u0627\u0645\u0644 \u0645\u0639\u0647 \u0628\u062c\u062f\u064a\u0629 \u0648\u0627\u0644\u062a\u0632\u0627\u0645 \u062a\u0627\u0645.",
    maitriseTechnique: "\u0625\u062a\u0642\u0627\u0646 \u062a\u0642\u0646\u064a",
    maitriseTechniqueDesc: "\u062e\u0628\u0631\u0629 \u0645\u0624\u0643\u062f\u0629 \u0641\u064a \u062c\u0645\u064a\u0639 \u062c\u0648\u0627\u0646\u0628 \u0627\u0644\u0628\u0646\u0627\u0621.",
    respectDelaisShort: "\u0627\u062d\u062a\u0631\u0627\u0645 \u0627\u0644\u0645\u0648\u0627\u0639\u064a\u062f",
    respectDelaisShortDesc: "\u0625\u0646\u062c\u0627\u0632 \u0627\u0644\u0623\u0639\u0645\u0627\u0644 \u0641\u064a \u0627\u0644\u0623\u0648\u0642\u0627\u062a \u0627\u0644\u0645\u062a\u0641\u0642 \u0639\u0644\u064a\u0647\u0627.",
    equipeQualifiee: "\u0641\u0631\u064a\u0642 \u0645\u0624\u0647\u0644",
    equipeQualifieeDesc: "\u0645\u0647\u0646\u064a\u0648\u0646 \u0630\u0648\u0648 \u062e\u0628\u0631\u0629 \u0648\u062a\u0641\u0627\u0646\u064a.",
    formName: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0643\u0627\u0645\u0644",
    formNamePlaceholder: "\u0627\u0633\u0645\u0643",
    formEmail: "\u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a",
    formEmailPlaceholder: "your@email.com",
    formPhone: "\u0627\u0644\u0647\u0627\u062a\u0641",
    formPhonePlaceholder: "+212 6XX XXX XXX",
    formSubject: "\u0627\u0644\u0645\u0648\u0636\u0648\u0639",
    formSubjectPlaceholder: "\u0645\u0648\u0636\u0648\u0639 \u0631\u0633\u0627\u0644\u062a\u0643",
    formMessage: "\u0627\u0644\u0631\u0633\u0627\u0644\u0629",
    formMessagePlaceholder: "\u0635\u0641 \u0645\u0634\u0631\u0648\u0639\u0643...",
    formSend: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629",
    formSending: "\u062c\u0627\u0631\u064a \u0627\u0644\u0625\u0631\u0633\u0627\u0644...",
    formSuccess: "\u062a\u0645 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629!",
    formSuccessDesc: "\u0634\u0643\u0631\u064b\u0627 \u0644\u0631\u0633\u0627\u0644\u062a\u0643. \u0633\u064a\u062a\u0648\u0627\u0635\u0644 \u0645\u0639\u0643 \u0641\u0631\u064a\u0642\u0646\u0627 \u0641\u064a \u0623\u0642\u0631\u0628 \u0648\u0642\u062a.",
    formAnother: "\u0625\u0631\u0633\u0627\u0644 \u0631\u0633\u0627\u0644\u0629 \u0623\u062e\u0631\u0649",
    formError: "\u062d\u062f\u062b \u062e\u0637\u0623. \u064a\u0631\u062c\u0649 \u0627\u0644\u0645\u062d\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649.",
    whatsappContact: "\u0623\u0648 \u062a\u0648\u0627\u0635\u0644 \u0645\u0639\u0646\u0627 \u0645\u0628\u0627\u0634\u0631\u0629 \u0639\u0628\u0631 \u0648\u0627\u062a\u0633\u0627\u0628:",
    navigation: "\u0627\u0644\u062a\u0635\u0641\u062d",
    contactTitle: "\u0627\u062a\u0635\u0644 \u0628\u0646\u0627",
    followUs: "\u062a\u0627\u0628\u0639\u0646\u0627",
    footerDesc: "KMSN \u0634\u0631\u0643\u0629 \u0645\u062a\u062e\u0635\u0635\u0629 \u0641\u064a \u0627\u0644\u0628\u0646\u0627\u0621 \u0648\u0627\u0644\u0623\u0634\u063a\u0627\u0644 \u0627\u0644\u0639\u0645\u0648\u0645\u064a\u0629\u060c \u062a\u062c\u0645\u0639 \u0628\u064a\u0646 \u0627\u0644\u062e\u0628\u0631\u0629 \u0648\u0627\u0644\u062c\u0648\u062f\u0629 \u0648\u0627\u0644\u0627\u0633\u062a\u062f\u0627\u0645\u0629.",
    allRights: "\u062c\u0645\u064a\u0639 \u0627\u0644\u062d\u0642\u0648\u0642 \u0645\u062d\u0641\u0648\u0638\u0629.",
    adminTitle: "KMSN \u0625\u062f\u0627\u0631\u0629",
    adminBack: "\u0627\u0644\u0639\u0648\u062f\u0629 \u0644\u0644\u0645\u0648\u0642\u0639",
    adminLogin: "\u062a\u0633\u062c\u064a\u0644 \u062f\u062e\u0648\u0644 \u0627\u0644\u0645\u0633\u0624\u0648\u0644",
    adminEmail: "\u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a",
    adminPassword: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
    adminLoginBtn: "\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644",
    adminMessages: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0648\u0627\u0631\u062f\u0629",
    adminNoMessages: "\u0644\u0627 \u0631\u0633\u0627\u0626\u0644 \u062d\u062a\u0649 \u0627\u0644\u0622\u0646",
    adminDetails: "\u0627\u0644\u062a\u0641\u0627\u0635\u064a\u0644",
    adminSelectMsg: "\u0627\u062e\u062a\u0631 \u0631\u0633\u0627\u0644\u0629",
    adminDelete: "\u062d\u0630\u0641 \u0647\u0630\u0647 \u0627\u0644\u0631\u0633\u0627\u0644\u0629",
    adminLoading: "\u062c\u0627\u0631\u064a \u0627\u0644\u062a\u062d\u0645\u064a\u0644...",
    adminTotalMessages: "\u0625\u062c\u0645\u0627\u0644\u064a \u0627\u0644\u0631\u0633\u0627\u0626\u0644",
    adminUnread: "\u063a\u064a\u0631 \u0645\u0642\u0631\u0648\u0621\u0629",
    adminLogout: "\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062e\u0631\u0648\u062c",
  },
};

const LangContext = createContext();

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("kmsn-lang") || "fr");

  useEffect(() => {
    localStorage.setItem("kmsn-lang", lang);
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => translations[lang]?.[key] || translations.fr[key] || key;

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
